<template>
  <div class="debug-menu" :style="{'top': (dragY-dragOffsetY)+'px', 'left': (dragX-dragOffsetX)+'px'}" v-if="visible">
    <div class="drag-handle" ref="dragHandle" @mousedown="startDrag"></div>
    <h2>Debug menu</h2>
    <ApiCallInterceptor></ApiCallInterceptor>
  </div>
</template>

<script>
import ApiCallInterceptor from './ApiCallInterceptor';

export default {
  name: "DebugMenu",

  components: {
    ApiCallInterceptor
  },

  data: function () {
    return {
      visible: false,
      isDragging: false,
      dragX: 0,
      dragY: 0,
      dragOffsetX: 0,
      dragOffsetY: 0,
    }
  },

  methods: {
    startDrag: function(e) {
      let dragHandle = this.$refs["dragHandle"];
      let bounds = dragHandle.getBoundingClientRect();
      this.dragOffsetX = e.clientX-bounds.left+11; // + padding + border
      this.dragOffsetY = e.clientY-bounds.top+11; // + padding + border
      this.dragX = e.clientX;
      this.dragY = e.clientY;

      document.addEventListener("mousemove",this.updateDragPosition);
      document.addEventListener("mouseup",this.endDrag);
    },

    updateDragPosition(e) {
      this.dragX = e.clientX;
      this.dragY = e.clientY;
    },

    endDrag: function() {
      document.removeEventListener("mousemove",this.updateDragPosition);
      document.removeEventListener("mouseup",this.endDrag);
    }
  },

  mounted: function() {
    window.showDebugMenu = () => {
      this.visible = true;
    };
  }
}


</script>

<style scoped>
  .debug-menu {
    position: fixed;
    top: 10px;
    left: 10px;
    min-width: 100px;
    min-height: 100px;
    border: 1px solid black;
    background: white;
    z-index: 100;
    padding: 10px;
  }

  h2 {
    margin: 0;
  }

  .drag-handle {
    background: #ccc;
    padding: 8px;
    cursor: grab;
    user-select: none;
  }
  .drag-handle:active {
    cursor: grabbing;
  }
</style>
